import type { StateFactory } from '@/injectionKeys';
import { stateFactoryKey } from '@/injectionKeys';

/**
 * チャット利用規約の同意状態管理
 * stateFactory パターンを使用してページ滞在中のみグローバル状態を保持する
 */
export const useChatConsent = () => {
  const stateFactory = inject(stateFactoryKey) as StateFactory;
  const hasConsented = stateFactory.create<boolean>('wabunkaChatConsent', false);

  const acceptTerms = () => {
    hasConsented.value = true;
  };

  return {
    hasConsented,
    acceptTerms,
  };
};
